
import { AutoMap } from "@automapper/classes";
import { NumberingMapping } from "../tools/mapping/numbering-mapping";
import { AreaMap } from "./area-map";
import { EActivitySimulationType } from "./enums/activity-simulation-type";
import { EBuildingType } from "./enums/building-type";
import { EDegradationLevel } from "./enums/degradation-level";
import { ERoomUsage } from "./enums/room-usage";
import { EZoneType } from "./enums/zone-type";
import { EZoneUsage } from "./enums/zone-usage";
import { ZoneMeasure } from "./zone-measure";


export class Zone {
    @AutoMap()
    Id!: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    Position!: number;
    @AutoMap()
    Description?: string;
    @AutoMap()
    CustomerReference?: string;
    @AutoMap()
    Type!: EZoneType;
    @AutoMap()
    Usage!: EZoneUsage;
    @AutoMap()
    BuildingType!: EBuildingType;
    @AutoMap()
    NonStandardBuildingType?: string;
    @AutoMap()
    RoomUsage!: ERoomUsage;
    @AutoMap()
    NonStandardRoomUsage?: string;
    // MASTER DATA
    OnSiteProtectionAndSealingType?: string;
    @AutoMap()
    ActivitySimulation?: EActivitySimulationType;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    IsDepose!: boolean;
    @AutoMap()
    DegradationLevel?: EDegradationLevel;

    @AutoMap(() => [ZoneMeasure])
    ZoneMesureList: ZoneMeasure[] = [];

    @AutoMap(() => [AreaMap])
    AreaMapList: AreaMap[] = [];

    public get Name() {
        if (this.Type === EZoneType.Outdoor) {
            return NumberingMapping.intTostring(this.Position + 1);
        }
        switch (this.Usage) {
            case EZoneUsage.PreWork:
                return NumberingMapping.intToUpperCaseCharacter(this.Position);
            case EZoneUsage.Environmental:
                return NumberingMapping.intTostring(this.Position + 1);
            case EZoneUsage.PostWork:
                return NumberingMapping.intToRoman(this.Position + 1);
            default:
                return;
        }
    }

    public constructor(init?: Partial<Zone>) {
        Object.assign(this, init);
    }

    static mapFromJSON(json: any): Zone {
        const a = new Zone;
        a.Id = json['id'];
        a.Code = json['code'];
        a.Position = json['position'];
        a.Description = json['description'];
        a.CustomerReference = json['customerRef'];
        // a.Category = json['category'];
        a.Usage = json['usage'];
        a.Type = json['type'];

        // a.Rooms = json['rooms'].map(jsonItem => Room.mapFromJson(jsonItem));
        // a.Measures = json['measures'].map(jsonItem => Measure.mapFromJson(jsonItem));
        // a.AreaMaps = json['areaMaps'].map(jsonItem => AreaMapDto.mapFromJson(jsonItem));

        // a.DegradationLevel = json['degradationLevel'];
        // a.BuildingType = json['buildingType'];
        // a.RoomUsage = json['roomUsage'];
        // a.OnSiteProtectionAndSealingType = json['onSiteProtectionAndSealingType'];
        // a.AirFlowType = json['airFlowType'];
        // a.BumpingAndVibrationType = json['bumpingAndVibrationType'];
        // a.ActivitySimulation = json['activitySimulation'];

        // a.MPCAIds = json['mpcaIds'].map(jsonItem => Number(jsonItem));
        return a;
    }
}
